export default __webpack_public_path__ + "static/media/mailIcon.441bdce0.svg";